module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_chipotle.cd1c7ad8.png";